<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Cadastro de Grupo de Usuários</strong>
        </div>
        <b-form @submit.stop.prevent>

        <b-form-group
          label="Nome"
          label-for="name">
          <b-form-input id="name" type="text" autocomplete="name" v-model="group.name"></b-form-input>
        </b-form-group>

        <b-form-group label="CPF/CNPJ" label-for="usernames" description="Informe a lista de CPF ou CNPJ separados por vírgula ou espaço.">
          <b-form-textarea id="usernames" v-model="usernamesStr" rows="3"></b-form-textarea>
        </b-form-group>

        <div v-if="errors.length">
          <b-alert show variant="warning"><strong>Usuários não encontrados:</strong>
            {{ errors.join(", ") }}
          </b-alert>
        </div>
      
        <div slot="footer">
          <b-row>
            <b-col sm="12" lg="2">
              <b-button class="form-control" type="submit" variant="primary" @click="save"><i class="fa fa-dot-circle-o"></i> Gravar</b-button>&nbsp;
            </b-col>
            <b-col sm="12" lg="2">
              <b-button type="button" variant="secondary" @click="goBack" class="form-control"><i class="fa fa-arrow-left"></i> Voltar</b-button>&nbsp;
            </b-col>
            <b-col sm="12" lg="2" v-if="group.id">
              <b-button type="button" variant="danger" @click="removeGroup"  class="form-control"><i class="fa fa-remove"></i> Remover</b-button>
            </b-col>
          </b-row>
        </div>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env } from '@/shared/utils';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'UserGroup',
  components: {
    Loading
  },
  data: () => {
    return {
      group: {
      },
      loadCount: 0,
      usernamesStr: "",
      errors: []
    }
  },
  mounted() {
    this.getGroup(this.$route.params.id);
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  methods: {
    getGroup(id) {
      if (!id) {
        return;
      }
      this.loadCount++;
      axios
        .get(`${env.urlBillingApi}/user-group/${id}`)
        .then((response) => {
          this.group = response.data;
          if (response.data.users) {
            this.usernamesStr = response.data.users.map((itm) => itm.username).join(", ");
          }
        })
        .catch((error) => {
          requestError(error, this);
        })
        .finally(() => {
          this.loadCount--;
        });
    },
    goBack() {
      this.$router.push('/user-groups');
    },
    save() {
      this.loadCount++;
      this.errors = [];
      // 48090777058, 58533726538, 75753553087, 123123123
      this.group.usernames = this.usernamesStr.trim().split(/[\s,]+/);
      var req;
      if (this.group.id) { // Novo ou removido
        req = axios.put(`${env.urlBillingApi}/user-group/${this.group.id}`, this.group);
      } else {
        req = axios.post(`${env.urlBillingApi}/user-group`, this.group);
      }
      req.then((response) => {
        if (response.data.notFound.length > 0) {
          this.errors = response.data.notFound;
          this.group.id = response.data.group.id;
          this.$bvModal.msgBoxOk('O grupo foi gravado com sucesso! Porém ocorreram alguns problemas.')
            .then().catch(console.log);
        } else {
          this.$bvModal.msgBoxOk('Grupo gravado com sucesso!')
            .then(value => {
              this.$router.push('/user-groups');
            }).catch(console.log);
        }
      })
      .catch((error) => {
        requestError(error, this);
      })
      .finally(() => {
        this.loadCount--;
      });
    },
    removeGroup() {
      var id = this.group.id;
      if (!id) return;
      this.$bvModal.msgBoxConfirm('Deseja realmente excluir o grupo?', {
        okVariant: 'danger',
        okTitle: 'Sim',
        cancelTitle: 'Não',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          this.loadCount++;
          axios
            .delete(`${env.urlBillingApi}/user-group/${id}`)
            .then((response) => {
              console.log(response);
              this.$bvModal.msgBoxOk('Grupo excluído com sucesso!')
                .then(value => {
                  this.$router.push('/user-groups');
                })
                .catch(console.error);
            })
            .catch((error) => {
              requestError(error, this);
            })
            .finally(() => {
              this.loadCount--;
            });
        }
      }).catch(alert);
    },
  }
}
</script>
